/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />
module Meevo.Components.Controls {
    "use strict";

    declare var intlTelInputUtils;

    export class MeevoPhoneNumber implements angular.IDirective {
        private filter: angular.IFilterService;
        restrict = "E";
        scope = {
            ngModel: "=ngModel",
            countryCode: "=?",
            disabled: "=ngDisabled",
            required: "=ngRequired",
            contentKey: "@?",
            securityAccessKey: "@?",
            ngBlur: "&?ngBlur",
            tabOnFlag: "@?",
            showClearFilter: "=?",
            ignoreValidation: "=?",
            updateModelWhenValid: "=?"  //this has no effect if ignoreValidation is true
        };
        /***
        *   Based on : intl-tel-input.js Review modifications made to source plugin - intl-tel-input.com
        **/
        template = `   
                    <div ng-form="MeevoPhoneForm">
                        <div class=\"meevo_input_wrapper\">
                            <label translate=\"{{::contentKey}}\"></label>
                            <div ng-class=\"{\'ng-dirty required_red_bubble \' : MeevoPhoneForm.$invalid || MeevoPhoneForm.$error.ngIntlTelInput.length > 0}\"></div>
                        </div>
                        <div class=\"meevo_input_wrapper\">
                            <input  type=\"tel\" id=\"phone\" name=\"meevoPhone\"
                                    ng-class=\"{'red_border_invalid' : MeevoPhoneForm.$invalid}\"
                                    ng-model=\"phone\"
                                    ng-disabled=\"disabled\"
                                    ng-required=\"required\"
                                    ng-focus=\"focusPhone()\"
                                    ng-blur=\"blurParsePhone()\"
                                    ng-keydown=\"saveCursorPos($event)\"
                                    ng-keyup=\"setCursorPos($event)\"
                                    title=\"{{contentKey | translate}}\"
                                    aria-label=\"{{contentKey | translate}}\"
                                    ng-intl-tel-input>
                            <button ng-if=\"showClearFilter\" class=\"meevo-typeahead-clearFilter\" type=\"button\" ng-disabled=\"disabled\" ng-click=\"clearPhone()\" style=\"top:30px;\"></button>
                            <br />
                            <div ng-messages="MeevoPhoneForm.meevoPhone.$error" class="error-messages">
                                <span ng-message="required" class=\"invalid\">Please enter phone number</span>
                                <span ng-message="ngIntlTelInput" class=\"invalid\">Invalid phone number</span>
                            </div>
                        </div>
                    </div>
                        `

        link = (scope: any, element: any, attrs: angular.IAttributes) => {
            scope.input = element.find('input');

            if (!scope.countryCode) {
                let dialCode = scope.input.intlTelInput('getSelectedCountryData').dialCode;
                scope.countryCode = dialCode;
            }

            scope.hasFocus = false;
            scope.focusPhone = () => {
                scope.hasFocus = true;
            }

            scope.$watch('ngModel', (newValue, oldValue) => {
                if (scope.hasFocus) {
                    return; // do not process any change to ngModel if changes come from this control
                }
                if (newValue != oldValue
                    && Model.Guard.isSomething(newValue)
                    && Model.Guard.isSomething(scope.countryCode)) {
                    scope.phone = scope.ngModel ? '+' + scope.countryCode + (scope.ngModel.toString().startsWith("0") ? scope.ngModel.substr(1) : scope.ngModel) : null;
                }
                else if (Model.Guard.isNothing(scope.ngModel)) {
                    scope.phone = scope.ngModel;
                }
                scope.doubleCountryCodeFix();
            });

            scope.phone = scope.ngModel ? '+' + scope.countryCode + (scope.ngModel.toString().startsWith("0") ? scope.ngModel.substr(1) : scope.ngModel) : null;
            scope.tabOnFlag = scope.tabOnFlag || '-1';
            element.find('div.selected-flag').attr("tabindex", scope.tabOnFlag);

            element.on("click", (event: JQueryEventObject) => {
                if (!scope.disabled) {
                    let target: any = event.target || event.srcElement;
                    if (target.id === scope.id) {
                        target.select();
                    }
                    event.preventDefault();
                }
            });

            // update validator
            scope.MeevoPhoneForm.meevoPhone.$validators.ngIntlTelInput = (value) => {
                if (!scope.ignoreValidation) {
                    // if phone number is deleted / empty do not run phone number validation
                    if (element) {
                        let elm: any = $(element).find("input#phone");
                        if (value || (elm && elm[0] && elm[0].value && elm[0].value.length > 0)) {
                            const isValid = elm.intlTelInput('isValidNumber');
                            const valdidationError = elm.intlTelInput('getValidationError');
                            if (isValid || valdidationError == 0) {
                                if (scope.updateModelWhenValid) {
                                    scope.parsePhone();
                                }
                                return true
                            }
                            return isValid;
                        }
                    }
                }
                return true;
            };

            scope.clearPhone = () => {
                scope.ngModel = scope.phone = '';
            }

            scope.blurParsePhone = () => {
                scope.parsePhone();
                try {
                    if (scope.ngBlur) {
                        this.$timeout(function() { scope.$eval(scope.ngBlur); }, 0);
                    }
                }
                catch (e) { console.log(e); /* do nothing */ }
                scope.hasFocus = false;
            }

            scope.parsePhone = () => {
                scope.ngModel = scope.input.intlTelInput("getNumber", intlTelInputUtils.numberFormat.NATIONAL).replace(/[^\d]/g, '');
            }

            element.on('countrychange', (event: JQueryEventObject) => {
                let metaData = scope.input.intlTelInput('getSelectedCountryData');
                const dialCode: string = String(metaData.dialCode);
                if (dialCode.startsWith("1") && dialCode.length == 4) {
                    // dialCode <> countryCode; any dialCode that starts with 1 and has 4 digits, its countryCode
                    // is 1 and the rest is the area code which will be contained in the phone number/ngModel
                    scope.countryCode = "1";
                }
                else {
                    scope.countryCode = metaData.dialCode;
                }
            });

            var cursorPos;
            var oldLength;
            scope.saveCursorPos = (e) => {
                if (scope.MeevoPhoneForm.$invalid) {
                    cursorPos = -1;
                } else {
                    var stringBeforeCursor = e.target.value.substring(0, e.target.selectionEnd);
                    var nonNumericCount = stringBeforeCursor.length - stringBeforeCursor.replace(/\D/g, '').length;
                    cursorPos = e.target.selectionEnd - nonNumericCount;
                    if (e.keyCode === 46) {
                        cursorPos++;
                    }
                }
                oldLength = e.target.value.replace(/\D/g, "").length;
            }

            scope.setCursorPos = (e) => {
                var newLength = e.target.value.replace(/\D/g, "").length;
                if (cursorPos > -1 && oldLength !== newLength) { //delete
                    if (oldLength > newLength) {
                        cursorPos -= oldLength - newLength;
                    } else {
                        cursorPos += newLength - oldLength;
                    }
                    e.target.setSelectionRange(cursorPos, cursorPos);
                }
            }

            scope.doubleCountryCodeFix = () => {
                const pattern = new RegExp(/^\+\d{1,4}\+/)
                if (scope.phone && scope.phone.match(pattern)) {
                    scope.phone = scope.phone.replace(pattern, "+");
                }
            }
        }

        constructor(private $timeout: angular.ITimeoutService) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = ($timeout) => {
                return new MeevoPhoneNumber($timeout);
            };
            directive.$inject = ["$timeout"];
            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoPhoneNumber", MeevoPhoneNumber.factory());
}
